var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{ref:"list",staticClass:"s-news-list__list"},_vm._l((_vm.news),function(article,index){return _c('Article',{key:'article' + index,attrs:{"article":article}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }